const loadingMessages = [
    "Remember, every bug you fix is a step closer to becoming a coding legend!",
    "While you wait, ponder the mysteries of semicolons and curly braces.",
    "In the world of coding, every problem has a solution. You just need to find it!",
    "Stay calm and keep coding. The perfect job match is just around the corner!",
    "Patience is a virtue, especially when waiting for servers to wake up. Keep calm and code on!",
    "Embrace the loading screen - it's a brief moment to relax before diving back into the tech world!",
    "Feeling stuck? Remember, even the greatest programmers were beginners once.",
    "In coding, as in life, sometimes you just need to hit refresh and try again.",
    "Take a deep breath and enjoy this moment of anticipation. Your dream job awaits!",
    "Loading... because even servers need their beauty sleep!",
    "Just a few more seconds... Your next big opportunity is worth the wait!",
    "What do you call a coding bootcamp graduate on their first day of work? Employed!",
    "Remember, even if it feels like your code is taking forever to load, progress is still being made.",
    "Coding tip: Always comment your code, but don't worry, your loading screen doesn't need comments!",
    "Loading... because even the most cutting-edge technology needs a moment to catch its breath!",
    "Keep calm and debug on. Your perfect job match is just a loading screen away!"
  ];

  export {loadingMessages}
